<template>
    <div id="app">
        <div v-if="showContent">
            <Header :user-info="userInfo" :game-info="gameInfo" @logout="logOut"></Header>
            <Step :steps-data="stepsData" :cur-step="curStep"/>
            <Work :works="works" :user-info="userInfo" :limit-start-time="getPublishStartTime()" :project-list="projectList" @getChooseWork="getChooseWork"
                  v-if="curStep === 0"></Work>
            <Information :user-information="userInformation" :prev="prev" @getUserInformation="getUserInformation"
                         v-if="curStep === 1"></Information>
            <Poster :user-info="userInfo" :game-info="gameInfo" :poster-file="posterFile" @postFile="postFile"
                    @removePostFile="removePostFile"
                    :prev="prev" @contribute="contribute"
                    v-if="curStep === 2"></Poster>
            <Success v-if="curStep === 3" :my-post-info="myPostInfo" @cancelPost="cancelPost"></Success>
            <Footer></Footer>
        </div>
        <div class="empty-game" v-else>
            The competition is unavailable, please confirm your source is correct.
        </div>
        <Modal :show-modal="showModal" :msg="msg" :need-cancel="false" @confirmModal="confirmModal"></Modal>
        <div class="my-modal-wrap" v-if="showMyModal">
            <div class="my-modal">
                <div class="text">Currently it's not in valid project submission date. Please close the page.</div>
            </div>
        </div>
    </div>
</template>

<script>
    import client, {CLIENT_ENV} from '@makeblock/passport-client'
    import Header from './components/Header.vue'
    import Footer from './components/Footer'
    import Step from './components/Step.vue'
    import Modal from './components/modal'
    import Work from './pages/home/work.vue'
    import Information from './pages/home/information'
    import Poster from './pages/home/poster'
    import Success from './pages/home/success'

    client.env = CLIENT_ENV.TEST

    export default {
        name: 'App',
        components: {
            Header,
            Footer,
            Step,
            Work,
            Information,
            Poster,
            Success,
            Modal,
        },
        data() {
            return {
                apiHeaders: null,
                gameInfo: {
                    id: 0,
                    name: '',
                    synopsis: '',
                    startTime: '',
                    endTime: '',
                    deliveryEndTime: '',
                    projectLimitation: {
                        eachMaxNum: 1,
                        publishEndTime: '',
                        publishStartTime: '',
                    },
                    status: '',
                },
                showContent: true,
                showMyModal: false,
                userInfo: null,
                myPostInfo: null,
                stepsData: [
                    {title: "Choose Your Project", status: 'undone', step: 0},
                    {title: "Fill In Personal Information", status: 'undone', step: 1},
                    {title: "Upload The Poster", status: 'undone', step: 2},
                    {title: "Submission Success", status: 'undone', step: 3},
                ],
                curStep: -1,
                works: [],
                projectList: [],
                userInformation: null,
                posterFile: null,
                showModal: false,
                msg: 'Project submission success! You can edit project or cancel submission in "Project Management".',
            }
        },
        beforeCreate() {
            document.title = 'Project submission'
        },
        created() {
            this.getGameInfo().then(() => {
                if (this.gameInfo.id) {
                    this.showContent = true
                    if (this.gameInfo.status === 1) { // 投稿中
                        this.getUserInfo().then(() => {
                            this.getMyPost()
                        })
                    } else {
                        this.showMyModal = true
                    }

                } else {
                    this.showContent = false
                }
            })
        },
        methods: {
            async getUserInfo() {
                client.env = process.env.VUE_APP_PASSPORT_ENV
                client.intl = true
                client.lang = 'en'
                if (client.token) {
                    this.utoken = client.token
                    try {
                        this.userInfo = await client.userInfo()
                        this.userInfo.utoken = client.token
                        this.apiHeaders = {
                            utoken: client.token
                        }
                    } catch (e) {
                        window.location.href = client.url
                    }
                } else {
                    window.location.href = client.url
                }
            },

            logOut() {
                client.logout().then(() => {
                    window.location.reload()
                })
            },

            getUrlParam(paraName) {
                let url = document.location.toString();
                let arrObj = url.split("?");
                if (arrObj.length > 1) {
                    let arrPara = arrObj[1].split("&");
                    let arr;
                    for (let i = 0; i < arrPara.length; i++) {
                        arr = arrPara[i].split("=");

                        if (arr != null && arr[0] == paraName) {
                            return arr[1];
                        }
                    }
                    return "";
                } else {
                    return "";
                }
            },

            async getGameInfo() {
                let gameId = this.getUrlParam('gameId')
                if (gameId) {
                    await this.$axios.get(`/game/v1/${gameId}`, {headers: this.apiHeaders}).then((resp) => {
                        if (resp.data.code === 0) {
                            this.gameInfo = resp.data.data
                        }
                    })
                }
            },

            getPublishStartTime() {
                let date = new Date(this.gameInfo.projectLimitation.publishStartTime * 1000)
                console.log(date)
                return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
            },

            backToPage() {
                window.location.href = `${process.env.VUE_APP_RETURN_URL}${this.gameInfo.id}`
            },

            getMyPost() {
                this.$axios.get(`/game/v1/${this.gameInfo.id}/my-projects`, {headers: this.apiHeaders}).then((resp) => {
                    if (resp.data.data && resp.data.data.length > 0) {
                        this.myPostInfo = resp.data.data[0]
                        this.curStep = 3
                    } else {
                        this.getMyWorks()
                        this.curStep = 0
                    }
                })
            },

            getMyWorks() {
                this.$axios.get(`/game/v1/${this.gameInfo.id}/to-delivery`, {headers: this.apiHeaders}).then((resp) => {
                    this.works = resp.data.data
                })
            },

            getChooseWork(pList) {
                this.projectList = [].concat(pList)
                this.next()
            },

            getUserInformation(userInformation) {
                this.userInformation = userInformation
                this.next()
            },

            postFile(posterFile) {
                this.posterFile = posterFile
            },

            removePostFile() {
                this.posterFile = null
            },

            contribute() {
                if (!this.posterFile)
                    return
                let userInformationFormat = Object.assign(this.userInformation, {address: this.userInformation.address.join(' ')})
                this.$axios.post('/game/v1/delivery', {
                    gameId: this.gameInfo.id,
                    projectList: this.projectList,
                    userInfo: userInformationFormat,
                    poster: this.posterFile
                }, {headers: this.apiHeaders}).then((resp) => {
                    if (resp.data.code === 0) {
                        this.showModal = true
                    }
                })
            },

            confirmModal() {
                this.showModal = false
                this.getMyPost()
            },

            cancelPost(projectId) {
                this.$axios.post('/game/v1/undelivery', {
                    gameId: this.gameInfo.id,
                    projectId,
                }, {headers: this.apiHeaders}).then((resp) => {
                    if (resp.data.code === 0) {
                        this.userInformation = null
                        this.posterFile = null
                        this.projectList = []
                        this.getMyPost()
                    }
                })
            },

            prev() {
                this.curStep--
            },
            next() {
                this.curStep++
            }
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        min-height: 100%;
        background: #000 url('assets/images/bg.png');
    }

    .empty-game {
        width: 100%;
        text-align: center;
        padding: 100px;
        font-size: 16px;
        color: #fff;
    }

    .my-modal-wrap {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .9);
        position: fixed;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .my-modal {
            width: 500px;
            height: 140px;
            border-radius: 8px;
            background: #fff;

            .text {
                padding: 45px;
                font-size: 16px;
                text-align: left;
            }

            .btn {
                display: block;
                width: 146px;
                margin: 0 auto;
                height: 46px;
                line-height: 46px;
                font-size: 16px;
                text-align: center;
                text-decoration: none;
                border-radius: 46px;
                background: #009ef6;
                color: #fff;
            }
        }
    }
</style>
